import { useEffect } from 'react';
import { refreshAppBadgeFromApi } from '../services/appBadge';

/**
 * Mantiene el número de notificaciones sin leer en el icono de la PWA (Badging API).
 */
export function useNotificationBadge(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;

    refreshAppBadgeFromApi().catch(() => undefined);

    const onFocus = () => refreshAppBadgeFromApi().catch(() => undefined);
    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        refreshAppBadgeFromApi().catch(() => undefined);
      }
    };
    const onSwMessage = (event: MessageEvent) => {
      if (event.data?.type === 'BADGE_REFRESH') {
        refreshAppBadgeFromApi().catch(() => undefined);
      }
    };

    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibility);
    navigator.serviceWorker?.addEventListener('message', onSwMessage);

    const timer = window.setInterval(() => {
      refreshAppBadgeFromApi().catch(() => undefined);
    }, 60_000);

    return () => {
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibility);
      navigator.serviceWorker?.removeEventListener('message', onSwMessage);
      clearInterval(timer);
    };
  }, [enabled]);
}
